import React, { useContext } from 'react';

import { QuizContext } from '../../store/quiz';
import { Email } from './Steps/Email';
import { Landing } from './Steps/Landing';
import { Select } from './Steps/Select';
import { Text } from './Steps/Text';
import { Age } from './Steps/Age';
import { WeightHeight } from './Steps/WeightHeight';
import { LoadingScreen } from './LoadingScreen';

export const Steps = ({ data, uid }) => {
  const {
    store: { currentScreenIndex, totalScreens, hideEmailStep, lastScreenIndex },
  } = useContext(QuizContext);

  const renderStep = () => {
    if (currentScreenIndex > lastScreenIndex) {
      return <LoadingScreen uid={uid} />;
    }

    if (currentScreenIndex === 0) {
      return <Landing heading={data.landing_heading} text={data.landing_text} />;
    }

    if (currentScreenIndex + 1 === totalScreens - 2) {
      return <Age />;
    }

    if (currentScreenIndex + 1 === totalScreens - 1) {
      return <WeightHeight />;
    }

    if (currentScreenIndex + 1 >= totalScreens) {
      if (hideEmailStep) return null;
      return <Email />;
    }

    const stepData = data.body[currentScreenIndex - 1];

    if (!stepData) {
      return null;
    }

    if (stepData.slice_type === 'quiz_text_step') {
      return <Text data={stepData} />;
    }

    if (stepData.slice_type === 'quiz_step') {
      return <Select data={stepData} />;
    }
  };

  return <>{renderStep()}</>;
};
